module.exports = __webpack_public_path__ + "img/thumbnail_buteemjtei.a77df582.png";